import { PathwayPopulated } from '@libs/src/models/pathway.interface';

export const PATHWAY_TEMPLATES = [
  {
    cover_photo:
      'https://storage.googleapis.com/ttc-static-images/pathway-manager-earlytalent.png',
    description:
      'This pathway empowers early talent with career development using mentoring, group learning sessions and networking.',
    goals: [
      'Goal setting and prioritization',
      'Networking',
      'Relationship building',
      'Communication',
      'Writing',
      'Emotional intelligence',
      'Time management',
      'Organizational awareness',
      'Adaptability',
      'Growth mindset',
      'Career planning',
    ],
    name: 'Early Talent',
  } as PathwayPopulated,
  {
    cover_photo:
      'https://storage.googleapis.com/ttc-static-images/pathway-careerdev.png',
    description:
      'This pathway empowers employees with career development using mentoring, group learning sessions and networking.',
    goals: [
      'Self-awareness',
      'Goal setting',
      'Critical thinking',
      'Accountability',
      'Communication',
      'Collaboration',
      'Adaptability',
      'Resilience',
      'Self-advocacy',
      'Relationship building',
      'Self-reflection',
      'Career planning',
    ],
    name: 'Career Development',
  } as PathwayPopulated,
  {
    cover_photo:
      'https://storage.googleapis.com/ttc-static-images/pathway-manager.A267111.png',
    description:
      'This pathway empowers managers with career development using mentoring, group learning sessions and networking',
    goals: [
      'Earning trust',
      'Building rapport',
      'Giving feedback',
      'Difficult conversations',
      'Delegating effectively',
      'Empowering action',
      'Coaching skills',
      'Performance talks',
      'Spotting burnout',
      'Setting boundaries',
      'Navigating change',
      'Embracing growth',
    ],
    name: 'Manager Effectiveness',
  } as PathwayPopulated,
  {
    cover_photo:
      'https://storage.googleapis.com/ttc-static-images/pathway-leadershipdev.154024185.345CF97.png',
    description:
      'This pathway empowers leaders with career development using mentoring, group learning sessions and networking',
    goals: [
      'Self-awareness',
      'Relationship building',
      'Business acumen',
      'Enterprise understanding',
      'Customer insights',
      'Leveraging diverse perspectives',
      'Decision-making',
      'Strategic thinking',
      'Change management',
      'Adaptability',
      'Spotting burnout',
      'Setting boundaries',
      'Career planning',
    ],
    name: 'Leadership Development',
  } as PathwayPopulated,
];
